<template>
	<div style="width: 810px;margin: 0 auto;padding-top: 150px;text-align: left;">
		<el-form ref="form" :model="form" label-width="150px" inline-message :rules="checkout">
			<el-form-item label="请输入原密码：" prop="rawpassword">
				<el-input v-model.trim="form.rawpassword" style="width: 60%;" type="password"></el-input>
				<!--<span style="margin-left: 5px;">密码长度6-12位！</span>-->
			</el-form-item>
			<el-form-item label="请输入新密码：" prop="onepassword" required>
				<el-input v-model.trim="form.onepassword" type="password" style="width: 60%;"></el-input>
			</el-form-item>
			<el-form-item label="请再次输入新密码：" prop="twopassword" required>
				<!--<p style="text-align: center;border: solid red 1px;">-->
				<el-input v-model.trim="form.twopassword" type="password" style="width: 60%;"></el-input>
				<!--</p>-->
				<!--<el-input v-model="form.onepassword"></el-input>-->
			</el-form-item>
			<el-form-item>
				<p style="text-align: center;width: 60%;">

					<el-button type="primary" @click="onSubmit">保存密码</el-button>
				</p>
				<!--<el-button type="primary" @click="onSubmit">保存密码</el-button>-->
				<!--<el-button>取消</el-button>-->
			</el-form-item>
		</el-form>
		<div>

		</div>

	</div>
</template>

<script>
	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				//				console.log(value)
				if(value === '') {
					callback(new Error('请输入密码'));
				} else {
					if(this.form.checkPass !== '') {
						this.$refs.form.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'));
				} else if(value !== this.form.onepassword) {
					callback(new Error('两次输入密码不一致，请重新输入!'));
				} else {
					callback();
				}
			};
			return {
				form: {
					rawpassword: '',
					onepassword: '',
					twopassword: ''
				},
				checkout: {
					rawpassword: [{
							required: true,
							message: '请输入原始密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
								message: '请输入6至20位的英文字母、数字或两者组合！',
							trigger: 'blur'
						},
						{
							pattern: /^[A-Za-z0-9_]+$/,
							message: '请输入6至20位的英文字母、数字或两者组合！',
							trigger: 'blur'
						},
					],
					onepassword: [{
							validator: validatePass,
							trigger: 'blur'
						},
						{
							pattern: /^[A-Za-z0-9_]+$/,
							message: '请输入6至20位的英文字母、数字或两者组合！',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
								message: '请输入6至20位的英文字母、数字或两者组合！',
							trigger: 'blur'
						}
					],

					twopassword: [{
							validator: validatePass2,
							trigger: 'blur'
						},
						{
							pattern: /^[A-Za-z0-9_]+$/,
								message: '请输入6至20位的英文字母、数字或两者组合！',
							trigger: 'blur'
						}
					]

				}
			}
		},
		created() {
//console.log(this.$store.state.IdcodeUserId)
//			if(this.$store.state.commonalityData.IdcodeUserId === '') {
//				this.$alert('请完善信息再使用此功能', '提示', {
//					confirmButtonText: '完善信息',
//					callback: action => {
//						if(action === 'confirm') {
//							this.$router.push({
//								path: 'perfect'
//							})
//						} else {
//							this.$router.push({
//								path: 'home'
//							})
//
//						}
//					}
//				});
//
//			}

		},
		methods: {
			onSubmit() {
				//				console.log('/api/IDcodeIndex/validateOldPwd')
				//					console.log(this.$store.state.commonalityData.IdcodeUserId);
				this.$refs.form.validate((valid) => {
					if(valid) {
						this.$http.post(this.$api + '/organUnit/editPassword', {
							oldPwd: this.form.rawpassword,
//							organunit_id: this.$store.state.commonalityData.IdcodeUserId,
							newPwd: this.form.twopassword
						}).then((resa) => {
							if(resa.body.result === 1) {
								this.$message({
									message: '保存成功',
									type: 'success'
								});
							} else {
								this.$message.error(resa.body.message);

							}

						})
						//						this.$http.get(this.$api + '/IDcodeIndex/validateOldPwd', {
						//							params: {
						//								oldPwd: this.form.rawpassword
						//							}
						//						}).then(res => {
						//							console.log(res)
						//
						//							if(res.body.result === 1) {
						//								this.saveData()
						//
						//							} else {
						//								this.$message.error(res.body.message);
						//
						//							}
						//
						//						})

					} else {
//						this.$message.error('请检查填写信息，重新提交');

					}
				})
			},
			saveData() {

			}
		}
	}
</script>

<style>

</style>